import { Button, ButtonGroup, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { arrowLeft, desktopIcon, searchIcon, } from "../../../constant/icons";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../layout/page";
import { useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { MigrationType } from "./type";
import { useApp } from "../../../components/app";
import { post } from "../../../helper/api";
import { getDate } from "../../../helper/utility";
import { message } from "../../../components/toast";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from 'yup';
import { useLoaderHelper } from "../../../helper/loaderHelper";
import { AddUpdateJob } from "../addUpdate/addUpdate";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import excel from "../../../assets/images/excel.svg"

const ReckonJobList = ({ api, closeAddUpdate }: any) => {
  const app = useApp()
  let navigate = useNavigate();
  const loader = useLoaderHelper();
  const addUpdate = useAddUpdate();
  let [migrationType, setMigrationType] = useState<MigrationType>('Full')
  const [selectedFunction, setSelectedFunction] = useState<number[]>([])
  const [filterModelOpen, setFilterModelOpen] = useState<boolean>(false)
  const toggleFilterModel = () => setFilterModelOpen(!filterModelOpen)
  const JobValidationSchema = Yup.object().shape({
    startDate: Yup.date()
      .required('From date is required')  // Ensures startDate is provided
      .typeError('From date must be a valid date'),  // Ensures the startDate is a valid date

    endDate: Yup.date()
      .required('To date is required')  // Ensures endDate is provided
      .typeError('To date must be a valid date')  // Ensures the endDate is a valid date
      .test('is-greater-than-start', 'To date cannot be earlier than From date', function (value) {
        const { startDate } = this.parent;  // Get the startDate from the parent object
        if (startDate && value && new Date(startDate) > new Date(value)) {
          return false;  // If startDate is greater than endDate, validation fails
        }
        return true;
      }),
  });
  //------------------------------------------------
  const [anyFileRequrid, setAnyFileRequrid] = useState<boolean>(false)
  const [refreshUI, setRefreshUI] = useState(false)
  const functionList = useMemo(() => {
    return app.currentApp?.functionList?.filter((x: any) => {
      let setting = JSON.parse(x.setting)
      if (migrationType != 'Basic') {
        return true;
      }
      return setting?.isBasicMigration
    }).map((item: any, index) => {

      return <li key={`${migrationType}${index}`}>
        <Input type="checkbox" id={`checkBox${index}`} onChange={(e) => {
          if (e.target.checked && !selectedFunction?.includes(item?.id)) {

            selectedFunction?.push(item?.id)
            setSelectedFunction(selectedFunction)
            setRefreshUI(!refreshUI)
          }
          else if (!e.target.checked) {
            setSelectedFunction(pre => pre?.filter(x => x != item?.id))

            setRefreshUI(!refreshUI)
          }
          app.currentApp?.functionList?.some(x => (selectedFunction.includes(x.id)) && x.functionColumns && x.functionColumns.length > 0) ? setAnyFileRequrid(true) : setAnyFileRequrid(false)
        }} checked={migrationType != 'Customization' ? true : selectedFunction?.includes(item?.id)} />
        <label htmlFor={`checkBox${index}`}>
          <div>
            <span>{desktopIcon.icon}</span>
            <h6>{item.functionName}</h6>
          </div>
          <div>
            <span>One</span>
            <h6>{item.functionCode}</h6>
          </div>
          {item.functionColumns && item.functionColumns.length > 0 && <div className="xlfile"> <img src={excel} alt="excel" />Excel File</div>}
        </label>
      </li>
    })
  }, [migrationType, selectedFunction.length, refreshUI])
  useEffect(() => {
    setSelectedFunction([])
  }, [migrationType])

  if (app.currentApp?.appCode === "rdo") {
    return (
      <AddUpdateJob
        closeAddUpdate={() => {
          closeAddUpdate();
        }}
        api={api}
        value={addUpdate.currentValue}
        app={app.currentApp?.appCode}
      />
    );
  }

  return (<PageLayout
    title={
      <>
        <Button
          color="link"
          onClick={() => navigate("/")}
          className="btn-back"
        >
          {arrowLeft.icon}{" "}
        </Button>
        Function
      </>
    }
    View={
      <>
        <div className="function-migrate-head">
          <ButtonGroup>
            <Button
              color="primary"
              outline
              active={migrationType == 'Full'}
              onClick={() => {
                setMigrationType('Full')
              }}
            >
              Full Migration
            </Button>
            <Button
              color="primary"
              outline
              active={migrationType == 'Basic'}
              onClick={() => {
                setMigrationType('Basic')
              }}
            >
              Basic Migration
            </Button>
            <Button
              color="primary"
              outline
              active={migrationType == 'Customization'}
              onClick={() => {
                setMigrationType('Customization')
              }}
            >
              Customization Migration
            </Button>
          </ButtonGroup>
          <div className="search_box">
            <Button color="link" className="p-0">
              {searchIcon.icon}
            </Button>

            <input
              name="searchbox"
              placeholder="Search.."
              type="search"
              className="top-element"
            />
          </div>
        </div>
        <ul className="migration-card-list">
          {functionList}
        </ul>
        <div className="btn-box maping-btn-box">
          <button className="btn btn-outline-dark" title="Back" type="button">Cancel</button>
          <button className="btn btn-primary" title="Confirm" onClick={() => {
            let allFunc: any[] | undefined = []
            if (migrationType != 'Customization') {
              allFunc = app.currentApp?.functionList?.filter((x: any) => {
                let setting = JSON.parse(x.setting)
                if (migrationType != 'Basic') { return true }
                return setting?.isBasicMigration
              }).map((item: any, index) => item.id)
              if (allFunc) {
                setSelectedFunction(allFunc)
              }
            }
            if ((migrationType != 'Customization' && allFunc && allFunc.length <= 0) || (migrationType == 'Customization' && selectedFunction?.length <= 0)) {
              message('warning', "Please select at least one function for migration.")
              return;
            }

            setFilterModelOpen(true)
          }} type="button">Confirm</button>
        </div>
        {filterModelOpen && <Modal
          toggle={toggleFilterModel}
          isOpen={filterModelOpen}
          scrollable
          centered
          backdrop="static"
          returnFocusAfterClose={false}
          keyboard={false}
          size="xl"

        >
          <ModalHeader toggle={toggleFilterModel}>
            Create New Job:
          </ModalHeader>
          <ModalBody className="jobModal">
            {anyFileRequrid ? <AddUpdateJob
              selectedFunction={selectedFunction}
              closeAddUpdate={() => {
                closeAddUpdate()
              }}
              api={api}
              value={addUpdate.currentValue}
              app={app.currentApp?.appCode}
            /> : <Formik
              initialValues={{
                name: "",
                remark: "",
                startDate: null,
                endDate: null,
                jobStartWithSubmit: true,
              }}
              validationSchema={JobValidationSchema}
              onSubmit={async (values) => {
                if (migrationType == 'Customization') {
                  if (selectedFunction?.length <= 0) {
                    message('warning', "Please select at least one function for migration.")
                    return;
                  }
                }
                post("createReckonJob", {
                  ...values,
                  tenantId: app.conversation.tenant[0].id,
                  functionList: selectedFunction
                }, undefined, loader).then((result) => {
                  closeAddUpdate()
                }).catch((error) => {

                })
              }}
            >
              {(formProps) => (
                <Form className="mx-0 content-box" onSubmit={formProps.handleSubmit}>
                  <div className="row file-process-header">
                    <FormGroup className="col-6 form-floating ps-0">
                      <Field
                        value={formProps.values.name}
                        className="form-control"
                        name="name"
                        placeholder="Enter Job Name"
                      />
                      <Label>Job Name</Label>
                    </FormGroup>
                    <FormGroup className="col-6 form-floating ps-0">
                      <Field
                        value={formProps.values.remark}
                        className="form-control"
                        name="remark"
                        placeholder="Enter Remark"
                      />
                      <Label>Job Remark</Label>
                    </FormGroup>
                    <FormGroup className="col-3 form-floating sticky_label ps-0">
                      <Field
                        name="startDate"
                        component={ReactDatePicker}
                        placeholderText={"DD/MM/YYYY"}
                        dateFormat={"dd/MM/yyyy"}
                        className="form-control w-100"
                        popperPlacement="auto"
                        selected={getDate(formProps.values?.startDate)}
                        onChange={(date: any, _: any) => {
                          formProps.setFieldValue("startDate", date);
                        }}
                      // popperModifiers={[
                      //   {
                      //     name: "preventOverflow",
                      //     options: {
                      //       boundary: "viewport", // Ensures it doesn't overflow the viewport
                      //     },
                      //   },
                      //   {
                      //     name: "flip",
                      //     options: {
                      //       fallbackPlacements: ["top-start", "top-end", "bottom-end"], 
                      //       padding: 10,
                      //       boundary: "clippingParents",
                      //       allowedAutoPlacements: ["top", "bottom", "right", "left"], 
                      //       // Adjusts to fit in viewport
                      //     },
                      //   },
                      // ]}                  
                      />
                      <ErrorMessage
                        name="startDate"
                        component="div"
                        className="text-danger"
                      />
                      <Label>
                        From Date<span style={{ color: "red" }}>*</span>
                      </Label>
                    </FormGroup>
                    <FormGroup className="col-3 form-floating ps-0 form-floating sticky_label">
                      <Field
                        name="endDate"
                        component={ReactDatePicker}
                        placeholderText={"DD/MM/YYYY"}
                        dateFormat={"dd/MM/yyyy"}
                        className="form-control w-100"
                        popperPlacement="auto"
                        selected={getDate(formProps.values?.endDate)}
                        onChange={(date: any, _: any) => {
                          formProps.setFieldValue("endDate", date);
                        }}
                        popperModifiers={[
                          {
                            name: "preventOverflow",
                            options: {
                              boundary: "viewport", // Ensures it doesn't overflow the viewport
                            },
                          },
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["top", "bottom"], // Adjusts to fit in viewport
                            },
                          },
                        ]}
                      />
                      <ErrorMessage
                        name="endDate"
                        component="div"
                        className="text-danger"
                      />
                      <Label>
                        to Date<span style={{ color: "red" }}>*</span>
                      </Label>
                    </FormGroup>
                    <FormGroup className="col-6 d-flex align-items-center gap-2">
                      <Label className="m-0 job_title_check">
                        <Field type="checkbox" name="jobStartWithSubmit" />
                        Job Start With Submit
                      </Label>
                    </FormGroup>
                  </div>
                  <Button
                    color="primary"
                    disabled={!formProps.isValid || formProps.isSubmitting}
                    className="review-submit"
                    type="submit"
                  >
                    Submit
                  </Button>
                </Form>
              )}
            </Formik>}
          </ModalBody>
        </Modal>}
      </>}
  />)
};
export { ReckonJobList };